import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const API_TIPO_PIEZAS = {
    getTipoPiezas: async () => {
        return await API.get('/tipo_piezas').then(res => res.data);
    },
    importarMedidas: async (excel) => {
        return API.post('tipo_piezas/import', excel, headers).then(res => res.data);
    },
}